import { render, staticRenderFns } from "./LiteracyDetail.vue?vue&type=template&id=2f331842&scoped=true"
import script from "./LiteracyDetail.vue?vue&type=script&lang=js"
export * from "./LiteracyDetail.vue?vue&type=script&lang=js"
import style0 from "./LiteracyDetail.vue?vue&type=style&index=0&id=2f331842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f331842",
  null
  
)

export default component.exports